module.exports = __webpack_public_path__ + "static/media/SPRIDAKUNSKAP.SE.v3.Intro.8a5577a5.mp4";